import { cloneDeep } from 'lodash-es'

// 菜单属性字段
const menuProps = {
  // children: 'children',
  label: 'name',
  icon: 'icon',
  route: 'route',
  key: 'code',
}
const firstLevel = 0

// 处理菜单数据
export function handleMenuData(menuList) {
  const { label, icon, route, key } = menuProps

  // 处理菜单数据
  function loopFn({ arr, level, firstIndex, breadcrumb = [] }) {
    return arr.map((item) => {
      item.level = level
      // if (!Object.prototype.hasOwnProperty.call(item, 'children') && Object.prototype.hasOwnProperty.call(item, children)) {
      //   item.children = [...item[children].filter((citem) => citem.type === 0)]
      //   delete item[children]
      // }

      item.label = item[label]
      delete item[label]

      item.icon = item[icon] ? `${item[icon]}|svg` : null

      if (item[route] && item[route] !== '#') {
        item.index = item[route]
        item.router = true
      } else {
        item.index = `${item[key]}`
      }

      item.breadcrumb = [...breadcrumb, item.index]

      if (level !== firstLevel) {
        item.firstIndex = firstIndex
      } else {
        firstIndex = item.index
      }

      if (item.children && item.children.length) {
        item.children = loopFn({
          arr: JSON.parse(JSON.stringify(item.children)),
          level: level + 1,
          firstIndex,
          breadcrumb: item.breadcrumb,
        })
      }

      return item
    })
  }

  return loopFn({
    arr: cloneDeep(menuList),
    level: firstLevel,
  })
}

// 获取第一个有效路由菜单
export function getFirstRouteIndex(list) {
  let ret = ''
  for (let i = 0, len = list.length; i < len; i += 1) {
    const target = list[i]
    if (target.router) {
      ret = target
    } else if (target.children && target.children.length) {
      ret = getFirstRouteIndex(target.children)
    }

    if (ret !== '') {
      return ret
    }
  }

  return ret
}

// 获取菜单map, index为key
export function setMenuIndexMapFn(list, result = {}) {
  return list.reduce((prev, item) => {
    const { index, children } = item
    prev[index] = item
    if (children && item.children.length) {
      prev = setMenuIndexMapFn(item.children, prev)
    }
    return prev
  }, result)
}

// 处理当前接口返回的数据结构，使其满足当前系统的菜单结构
export function handleMenuItemForSys(list = []) {
  return list
    .filter((item) => {
      return item.funcType !== 2
    })
    .map((item) => {
      const { children = [] } = item
      const newChildren = children && children.length ? handleMenuItemForSys(children) : children
      let newItem = {
        name: item.funcName,
        type: item.funcType,
        icon: item.iconStyle,
        code: item.id,
        route: item.url,
      }
      return {
        ...newItem,
        children: [...newChildren],
      }
    })
}
